export const kebabToCamelCase = (s: string) =>
  s.replace(/-(.)/g, (_, m1) => m1.toUpperCase());
